import { isArrayEmpty } from "../omnia"
import { IDashboardService } from "../types"
import { CroppingInfo } from "./cropping-info"
import { NotificationGroup } from "./types"

export function checkPSorpCapacity(svc: IDashboardService, cropping: CroppingInfo[]): NotificationGroup {

    const { holding } = svc

    const year = holding.CropYears.find(y => y.YearId === svc.yearId)

    if (year.PkModel !== "SRUC") {
        return
    }

    if (holding.PSorpCapacity) {
        return
    }

    const fields = cropping
        .filter(c => c.nutrition.hasRequirements)
        .map(c => c.field)
        .unique(f => f.fieldId)
        .filter(f => !f.psorpCapacity)

    if (isArrayEmpty(fields)) {
        return
    }

    const details = fields.map(f => ({
        text: f.description
    }))

    return {
        id: "nutrition-sruc-psorp-notset",
        summary: "P sorp capacity not set",
        description: `<p>You are using the SRUC model to assess crop requirements, and some fields do not have a P sorp capacity set.</p>`,
        details,
    }

}

